import { useEffect, useState } from 'react';
import { dataFaqList } from 'core/dataFaqAdditionalServices';

import { Box, Typography, AccordionSummary, Collapse } from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { AccordionCustom, LinkExternal, AccordionDetailsCustom } from './styles';

const Faq = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (window.innerWidth > 992) {
            setIsOpen(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window]);

    return (
        <Box sx={{ marginTop: '1.56rem' }}>
            <Box sx={{ pointerEvents: { xs: 'auto', md: 'none' }, display: 'flex', marginBottom: '.6rem', cursro: { xs: 'pointer', md: 'default' }, 'svg': { display: { xs: 'block', md: 'none' }, transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: '300ms' } }} onClick={() => setIsOpen(!isOpen)}>
                <Typography sx={{ fontSize: { xs: '1rem', md: '1.25rem' }, borderLeft: '4px solid #97C93D', padding: { xs: '.6rem 0 .4rem .5rem', md: '.375rem 0 .275rem .8rem' } }}>
                    <b>Dúvidas</b> sobre serviços adicionais Ituran
                </Typography>
                <ExpandMoreIcon color='secondary' fontSize='large' />
            </Box>

            <Collapse in={isOpen}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '.8rem' }}>
                    {dataFaqList.map(({ question, answer }, index) =>
                        <AccordionCustom key={index}>
                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon color='secondary' fontSize='large' />}>
                                <Typography fontSize='.9375rem' lineHeight='18px' fontWeight={600}>
                                    {question}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetailsCustom>
                                <Typography fontSize='1rem' lineHeight='1.2rem' dangerouslySetInnerHTML={{ __html: answer }} />
                            </AccordionDetailsCustom>
                        </AccordionCustom>
                    )}
                    <LinkExternal href="https://www.ituran.com.br/atendimento/fale-conosco" target='_blank'>
                        VER TODAS AS DÚVIDAS
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none">
                            <path d="M5.13482 3.91691C5.02384 4.01085 4.85736 4.07349 4.69089 4.07349C4.52442 4.07349 4.35794 4.01085 4.24696 3.91691L0.861988 1.05149C0.621525 0.847935 0.621525 0.503459 0.861988 0.299905C1.10245 0.0963508 1.50939 0.0963508 1.74985 0.299905L4.69089 2.77387L7.61343 0.299905C7.74291 0.190299 7.89089 0.143325 8.05736 0.143325C8.22384 0.143325 8.39031 0.190299 8.50129 0.299905C8.74176 0.503459 8.74176 0.847935 8.50129 1.05149L5.13482 3.91691Z" fill="#0C1C33" />
                        </svg>
                    </LinkExternal>
                </Box>
            </Collapse>
            {!isOpen &&
                <Box sx={{ display: { xs: 'block', md: 'none' }, height: '1px', width: '100%', backgroundColor: '#B2B2B2' }} />
            }
        </Box>
    );
}

export default Faq;